(function () {
  'use strict';

  angular
    .module('cure', [
      'ngAnimate',
      'ngCookies',
      'ngTouch',
      'ngSanitize',
      'ngMessages',
      'ngAria',
      'ngResource',
      'ngRoute',
      'firebase',
      'mm.foundation',
      'toastr']);

})();

(function () {
  'use strict';

  angular
    .module('cure')
    .factory('Vote', function ($q, $log, Discog, Utils) {

      var ratings,
        track;

      function initTrack(releaseId, trackId, userId) {
        var promise;
        track = Discog.getTrack(releaseId, trackId);
        promise = track.$loaded();
        return promise
          .then(function (track) {
            return getUserRating(userId, trackId);
          })
          .then(function (rating) {
            return { track: track, ratings: ratings };
            // return reject({status:503, statusText:'Just broken...'}); // to test...
          });
      }

      function getUserRating(userId, trackId) {
        ratings = Discog.getRatings(userId, trackId);
        // $value null if never voted, else the number last voted
        return ratings
          .$loaded()
          .then(function (rating) {
            if (rating.$value === null) {
              rating.$value = 0;
            }
            return rating;
          });
      }


      function updateUserVote(ratings, newVote) {
        ratings.$value = newVote;
        return ratings.$save();
      }

      function updateVoteTotals(releaseId, trackId, currentVote, newVote) {
        var trackRef = Discog.trackRef(releaseId, trackId);
        return trackRef
          .transaction(function (trackUpdate) {
            if (trackUpdate) {
              trackUpdate.total += (newVote - currentVote);
              if (currentVote === 0) {
                trackUpdate.votes++;
              }
            }
            return trackUpdate;
          });
      }

      function updateTrackAverage(trackId, rankData) {
        return Discog.setRank(trackId, rankData);
      }

      function vote(trackId, newVote) {
        if (!newVote) {
          return reject({ status: 400, statusText: 'No value sent to vote!' });
        } else if (!trackId) {
          return reject({ status: 400, statusText: 'Missing trackId, can\'t vote...' });
        }

        var promiseRatings,
          promiseTrans,
          currentVote = ratings.$value,
          releaseId = track.albumId;

        // 1. Update user vote
        promiseRatings = updateUserVote(ratings, newVote);
        // 2. Transaction to update vote count and total
        promiseTrans = updateVoteTotals(releaseId, trackId, currentVote, newVote);

        return $q.all([promiseRatings, promiseTrans])
          .then(function (data) {
            if (data && data[1]) {
              var updatedTrack = data[1].snapshot.val(),
                rankData = getRankData(updatedTrack);
              // 3. Set the average vote
              return updateTrackAverage(trackId, rankData)
                .then(function () {
                  return newVote;
                });
            } else {
              return reject({ status: 405, statusText: 'Update of votes failed' });
            }
          });
      }

      function getRankData(track) {
        return {
          average: Utils.getAverage(track.total, track.votes),
          title: track.title,
          id: track.id,
          albumId: track.albumId
        };
      }

      function reject(reason) {
        reason = reason || { status: 404, statusText: 'Not Found' };
        var deferred = $q.defer();
        deferred.reject(reason);
        return deferred.promise;
      }

      function resolve(data) {
        data = data || {};
        var deferred = $q.defer();
        deferred.resolve(data);
        return deferred.promise;
      }

      function destroy() {
        ratings.$destroy();
        track.$destroy();
        return true;
      }

      return {
        vote: function (trackId, value) {
          return vote(trackId, value);
        },
        initTrack: function (releaseId, trackId, userId) {
          return initTrack(releaseId, trackId, userId);
        },
        getUserRatings: function () {
          return ratings;
        },
        destroy: function () {
          return destroy();
        }
      }

    });

})();
(function () {
  'use strict';

  angular
    .module('cure')
    .component('votingButtons', {
      bindings: {
        votes: '<',
        max: '<',
        onVote: '&'
      },
      controller: function (Utils) {
        this.getRepeat = Utils.getRepeat;
      },
      templateUrl: 'app/components/vote/vote.html'
    });

})();

(function () {
  'use strict';

  angular
    .module('cure')
    .factory('Utils', function () {

      var utils = {

        getRepeat: function (n) {
          return new Array(n);
        },

        getAverage: function (total, votes) {
          if (total === 0 || votes === 0) {
            return 0;
          }
          return Math.floor(total / votes) || 0;
        }
      };

      return utils;
    });

})();

(function () {
  'use strict';

  angular
    .module('cure')
    .component('ratingBar', {
      bindings: {
        total: '<',
        votes: '<',
        max: '<',
        showDetails: '<'
      },
      controller: function ($log, Utils) {

        this.getRepeat = Utils.getRepeat;
        this.getAverage = Utils.getAverage;

        // this.$onInit = function() {
        //     $log.info('ratingBar component initialized');
        // };
      },
      templateUrl: 'app/components/rating/rating.html'
    });

})();

// Note: component defaults to controllerAs: '$ctrl'
(function () {
  'use strict';

  angular
    .module('cure')
    .component('navbar', {
      controller: function ($location, $log, Auth) {

        var $ctrl = this; // to access from $onAuthStateChanged
        this.user = null;
        this.signout = signout;
        this.active = active;

        function signout() {
          Auth
            .$signOut()
            .then(function () {
              $location.path('/');
            });
        }

        function active(location) {
          return location === $location.path();
        }

        // Equiv. of $window.firebase.onAuthStateChanged
        Auth.$onAuthStateChanged(function (user) {
          $ctrl.user = user;
        });
      },
      templateUrl: 'app/components/navbar/navbar.html'
    });

})();

(function () {
  'use strict';

  angular
    .module('cure')
    .controller('TrackController', TrackController);

  function TrackController($routeParams, $timeout, $log, $scope, $location, Vote, Discog, Utils, user, toastr) {
    var vm = this,
      track,
      votes,
      releaseId = $routeParams.id,
      trackId = $routeParams.track;

    vm.onVote = onVote;
    vm.getAverage = Utils.getAverage;

    if (!releaseId || !trackId || !user.uid) {
      $location.path('/');
      return;
    }

    Vote.initTrack(releaseId, trackId, user.uid)
      .then(function (data) {
        track = vm.track = data.track;
        votes = vm.votes = data.ratings;
      }).catch(function (reason) {
        toastr.error(reason.statusText, 'Error', {
          onHidden: function () {
            $location.path('/');
          }
        });
      });

    // Don't like... A child route would be better (ui-router) - or a ref in a service - rather
    // than making another request
    Discog.getCover($routeParams.id).then(function (image) {
      vm.cover = image;
    });

    function onVote(event) {
      Vote.vote(trackId, event.value)
        .then(function (results) {
          // $log.info('onVote : vote counted!', results);
        }, function (reason) {
          $log.info('Error : ', reason);
          toastr.error(reason.statusText, 'Error');
        });
    }

    // To clean up angularfire references (stop permission errors...)
    $scope.$on('$destroy', function () {
      // vm.cover.$destroy(); // only need when using $firebaseObject : not when using .once
      Vote.destroy && Vote.destroy();
    });

  }

})();

(function () {
  'use strict';

  angular
    .module('cure')
    .controller('ReleaseController', ReleaseController);

  function ReleaseController($routeParams, $location, Discog, toastr) {
    var vm = this;
    vm.releaseId = $routeParams.id;

    // Use once : don't need to keep on tracking/waiting for update
    Discog.getRelease($routeParams.id).then(function (data) {
      vm.release = data[0];
      vm.tracks = data[1];
    }, function (reason) {
      toastr.error(reason.statusText, 'Error', {
        onHidden: function () {
          $location.path('/');
        }
      });
    });

  }

})();

(function () {
  'use strict';

  angular
    .module('cure')
    .factory('FirebaseUtils', function ($window) {

      function firebaseRef(path) {
        // var ref = $window.firebase.database().ref(),
        var ref = firebase.database().ref(),
          args = Array.prototype.slice.call(arguments);
        if (args.length) {
          ref = ref.child(pathRef(args));
        }
        return ref;
      }
      function pathRef(args) {
        for (var i = 0; i < args.length; i++) {
          if (angular.isArray(args[i])) {
            args[i] = pathRef(args[i]);
          }
          else if (!angular.isString(args[i])) {
            throw new Error('Argument ' + i + ' to firebaseRef is not a string: ' + args[i]);
          }
        }
        return args.join('/');
      }

      return {
        // There's only a global reference - seems odd for angularfire not to include service, but still.
        firebase: function () {
          return firebase.database().ref();
          // Same as:
          // return $window.firebase.database().ref();
        },
        timestamp: firebase.database.ServerValue.TIMESTAMP,
        // Same as:
        // timestamp: $window.firebase.database.ServerValue.TIMESTAMP,

        ref: firebaseRef
      }
    });

})();

(function () {
  'use strict';

  angular
    .module('cure')
    .factory('Discog', function ($timeout, $q, $firebaseObject, $firebaseArray, FirebaseUtils) {

      function getAlbum(releaseId) {
        var albumRef = FirebaseUtils.ref('releases/' + releaseId);

        return albumRef.once('value').then(function (dataSnapshot) {
          return $timeout(function () {
            return dataSnapshot.val();
          });
        });
      }

      function getTracks(releaseId) {
        var tracksRef = FirebaseUtils.ref('tracks/' + releaseId);

        return tracksRef.once('value').then(function (dataSnapshot) {
          return $timeout(function () {
            return dataSnapshot.val();
          });
        });
      }

      function getTrackRef(releaseId, trackId) {
        return FirebaseUtils.ref('tracks/' + releaseId + '/' + trackId);
      }
      
      function getRatingsRef(userId, trackId) {
        return FirebaseUtils.ref('users/' + userId + '/ratings/' + trackId);
      }

      var api = {

        getDiscog: function (artist) {
          var discogRef = FirebaseUtils
            .ref('artist/' + artist + '/discog')
            .orderByChild('releaseYear');

          return $firebaseArray(discogRef);
        },

        getCover: function (releaseId) {
          var coverRef = FirebaseUtils.ref('releases/' + releaseId + '/coverFront');

          return coverRef.once('value').then(function (dataSnapshot) {
            return $timeout(function () {
              return dataSnapshot.val();
            });
          });
        },

        getRanks: function (limit) {
          var ranksRef = FirebaseUtils
            .ref('ranks')
            .orderByChild('average')
            .limitToLast(limit);

          return $firebaseArray(ranksRef);
        },

        // Don't need to track or keep hold of, so don't keep the overhead of a $firebaseObject
        setRank: function (trackId, data) {
          var rankRef = FirebaseUtils
            .ref('ranks/' + trackId)
            .set(data);
          return rankRef;
        },

        getRatings: function (userId, trackId) {
          return $firebaseObject(getRatingsRef(userId, trackId));
        },
        ratingsRef: function (userId, trackId) {
          return getRatingsRef(userId, trackId);
        },

        getTrack: function (releaseId, trackId) {
          return $firebaseObject(getTrackRef(releaseId, trackId));
        },
        trackRef: function (releaseId, trackId) {
          return getTrackRef(releaseId, trackId);
        },

        // Get the album (or whatever) plus its tracks
        getRelease: function (releaseId) {
          return $q.all([getAlbum(releaseId), getTracks(releaseId)]);
        }

      };

      return api;

    });

})();

(function () {
  'use strict';

  angular
    .module('cure')
    .controller('DiscogController', DiscogController);

  function DiscogController($scope, Discog) {
    var vm = this;

    vm.discog = Discog.getDiscog('The Cure');

    // To clean up angularfire references (stop permission errors...)
    $scope.$on('$destroy', function () {
      vm.discog.$destroy && vm.discog.$destroy();
    });

  }
})();
(function () {
  'use strict';

  angular
    .module('cure')
    .factory('Auth', function ($firebaseAuth) {
      return $firebaseAuth();
    });

})();

(function () {
  'use strict';

  angular
    .module('cure')
    .controller('AuthController', function ($location, $log, $scope, Discog, Auth, toastr) {

      var vm = this;
      vm.oauthLogin = oauthLogin;
      vm.user = null;
      // Show top X by votes : will update live as/when top X changes
      vm.topTracks = Discog.getRanks(5);

      function oauthLogin(providerName) {
        if (!providerName) {
          return;
        }
        Auth.$signInWithPopup(providerName)
          .then(function (result) {
            $location.path('/release');
          }).catch(function (reason) {
            $log.warn('error ::: ', reason);
            toastr.error(reason.statusText, 'Error', {
              onHidden: function () {
                $location.path('/');
              }
            });
          });
      }

      Auth.$onAuthStateChanged(function (user) {
        vm.user = user;
      });

      // To clean up angularfire references (stop permission errors...)
      $scope.$on('$destroy', function () {
        vm.topTracks.$destroy && vm.topTracks.$destroy();
      });

    });

})();

(function () {
  'use strict';

  angular
    .module('cure')
    .run(runBlock);

  function runBlock($log, $window, $rootScope, $location) {

    var r = $rootScope.$on('$routeChangeError', function (event, next, previous, error) {
      // We can catch the error thrown when the $requireSignIn promise is rejected
      // and redirect the user back to the home page
      if (error === 'AUTH_REQUIRED') {
        $location.path('/');
      }
    });

  }

})();

(function () {
  'use strict';

  angular
    .module('cure')
    .config(routeConfig);

  function routeConfig($routeProvider) {

    $routeProvider.whenAuthenticated = function (path, route) {
      route.resolve = route.resolve || {};
      route.resolve.user = ['Auth', function (Auth) {
        return Auth.$requireSignIn();
      }];
      $routeProvider.when(path, route);
      return this;
    }

    $routeProvider
      .when('/', {
        templateUrl: 'app/auth/login.html',
        controller: 'AuthController',
        controllerAs: 'vm',
        resolve: {
          requireNoAuth: ['$location', 'Auth', function ($location, Auth) {
            return Auth.$requireSignIn().then(function (auth) {
              $location.path('/discog');
            }, function (error) {
              return;
            });
          }]
        }
      })
      .when('/about', {
        templateUrl: 'app/about/about.html'
      })
      .whenAuthenticated('/discog', {
        templateUrl: 'app/discog/discog.html',
        controller: 'DiscogController',
        controllerAs: 'vm'
      })
      .whenAuthenticated('/discog/:id', {
        templateUrl: 'app/release/release.html',
        controller: 'ReleaseController',
        controllerAs: 'vm'
      })
      .whenAuthenticated('/discog/:id/:track', {
        templateUrl: 'app/track/track.html',
        controller: 'TrackController',
        controllerAs: 'vm'
      })
      .otherwise({
        redirectTo: '/'
      });
  }

})();

(function () {
  'use strict';

  angular
    .module('cure')
    .config(config);

  function config($logProvider, $locationProvider, toastrConfig) {

    $logProvider.debugEnabled(true);

    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 2000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = false;     // true prevents same as last toast : don't want
    toastrConfig.preventOpenDuplicates = true;  // true prevents the same toast as is currently showing
    toastrConfig.maxOpened = 1;
    toastrConfig.progressBar = true;

    $locationProvider.html5Mode(true);

  }

})();

angular.module("cure").run(["$templateCache", function($templateCache) {$templateCache.put("app/about/about.html","<div class=container><div class=row><div class=\"small-12 text-center columns\"><h1>About</h1></div><div class=\"small-12 text-center columns\"><div class=\"panel text-left\"><p>An <a href=https://www.angularjs.org/ >Angular</a> 1.5 (@1.6.0) app with a <a href=https://firebase.google.com/ >Firebase</a> backend. View and rate albums/releases by The Cure. These are from my collection - CDs only.<br>I used <a href=http://www.collectorz.com/music/ >Music Collector</a> to scan my CDs and export the data, with a little massaging to get a Firebase friendly denormalized state.<br>One day I might get round to adding my vinyl etc. too - though that would take a long, long time. I have lots :-)</p><p>The CD cover images are as exported from Music Collector - far too many to rename to something nice, so they are what they are.</p></div></div></div></div>");
$templateCache.put("app/auth/login.html","<div class=container><div class=row><div class=\"large-12 text-center columns\"><div class=\"panel login-panel\"><div class=login-buttons ng-if=!vm.user><button class=\"secondary button\" ng-click=\"vm.oauthLogin(\'google\')\">Google</button> <button class=\"secondary button\" ng-click=\"vm.oauthLogin(\'facebook\')\">Facebook</button></div></div></div></div><div class=row><div class=\"small-8 small-offset-2 text-center columns\"><ul class=\"menu simple topthree\"><li ng-repeat=\"track in vm.topTracks | orderBy:\'-average\'\"><small>{{track.title}} ({{track.average}})</small></li></ul></div></div></div>");
$templateCache.put("app/discog/discog.html","<div class=container><div class=row><div class=\"large-12 text-center columns\"><img src=images/the-cure.png alt=\"The Cure\"></div></div><div class=\"row small-up-2 medium-up-3 large-up-4\"><div class=\"column release\" ng-repeat=\"release in vm.discog\"><a ng-href=\"discog/{{ release.$id}}\">{{ release.title}}</a></div></div></div>");
$templateCache.put("app/release/release.html","<div class=container><div class=row ng-hide=!vm.release.artist><div class=\"small-12 text-center columns\"><a ng-href=discog><img src=images/the-cure.png alt=\"The Cure\"></a><h1>{{vm.release.title}}</h1><small>{{vm.release.releaseDate}}</small></div><div class=\"small-12 medium-6 text-center columns\"><div class=panel><img class=cover ng-src=images/covers/{{vm.release.coverFront}}><ul class=\"menu simple\"><li><small>Label: {{vm.release.label}}</small></li><li><small>Tracks: {{vm.release.tracks}}</small></li></ul></div></div><div class=\"small-12 medium-6 panel-column columns\"><div class=\"panel text-left\"><ol><li class=tracks ng-repeat=\"track in vm.tracks\"><a ng-href=discog/{{vm.releaseId}}/{{track.id}}>{{track.title}}</a></li></ol></div></div></div></div>");
$templateCache.put("app/track/track.html","<div class=container><div class=row ng-hide=!vm.track.artist><div class=\"small-12 text-center columns\"><a ng-href=discog><img src=images/the-cure.png alt=\"The Cure\"></a><h1 class=release-title><a ng-href=discog/{{vm.track.albumId}}>{{vm.track.albumTitle}}</a></h1><small>{{vm.track.releaseDate}}</small></div><div class=\"small-12 medium-6 text-center columns\"><div class=panel><img class=cover ng-src=images/covers/{{vm.cover}}></div></div><div class=\"small-12 medium-6 panel-column columns\"><div class=\"panel panel-ratings\"><h2>{{vm.track.title}}</h2><rating-bar total=vm.track.total votes=vm.track.votes max=5 show-details=true></rating-bar><ul class=\"menu simple\"><li>Position: {{vm.track.position}}</li><li>Length: {{vm.track.length}}</li></ul><voting-buttons on-vote=vm.onVote($event) votes=vm.votes max=5></voting-buttons></div></div></div></div>");
$templateCache.put("app/components/navbar/navbar.html","<div class=top-bar><div class=top-bar-left><ul class=menu><li ng-class=\"{ active: $ctrl.active(\'/\') || $ctrl.active(\'/discog\') }\"><a ng-href=/ >Home</a></li></ul></div><div class=top-bar-right ng-if=$ctrl.user><ul class=\"menu float-right\"><li ng-class=\"{ active: $ctrl.active(\'/about\') }\"><a ng-href=about>About</a></li><li><button class=\"hollow button success\" ng-click=$ctrl.signout()>Sign Out</button></li></ul></div></div>");
$templateCache.put("app/components/rating/rating.html","<div><div class=rating><span ng-class=\"{ \'selected\': ($ctrl.total/$ctrl.votes) >= ($index + 0.5)}\" ng-repeat=\"i in $ctrl.getRepeat($ctrl.max) track by $index\">☆</span></div><div ng-if=$ctrl.showDetails><small>Votes Cast: {{$ctrl.votes}}</small> | <small>Rating: {{$ctrl.getAverage($ctrl.total, $ctrl.votes)}}</small></div></div>");
$templateCache.put("app/components/vote/vote.html","<div class=rate-buttons><h4>Rate</h4><div class=button-group><button class=button ng-class=\"{ \'alert\': $ctrl.votes.$value === ($index + 1)}\" ng-click=\"$ctrl.onVote({$event: {value: ($index + 1)}});\" ng-repeat=\"i in $ctrl.getRepeat($ctrl.max) track by $index\">{{$index + 1}}</button></div><small>Your Rating: {{$ctrl.votes.$value || 0}}</small></div>");}]);